import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.asClass), {
    class: _normalizeClass(["wrapper", _ctx.classes || []]),
    ref: `component`,
    style: _normalizeStyle({
            display: _ctx.display || 'auto',
            cursor: _ctx.cursor,
        }),
    onMouseenter: _ctx.start,
    onMouseleave: _ctx.stop
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "component", { class: "component" }, undefined, true),
      (_ctx.isHovered)
        ? (_openBlock(), _createBlock(_Teleport, {
            key: 0,
            to: "body"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["tooltipWrapper", {
                    withWrapper: _ctx.tooltipWithWrapper,
                }]),
              "data-bs-theme": "dark",
              style: _normalizeStyle(_ctx.tooltipStyle),
              onMousemove: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stop && _ctx.stop(...args)))
            }, [
              _renderSlot(_ctx.$slots, "tooltip", {}, undefined, true)
            ], 38)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 40, ["style", "class", "onMouseenter", "onMouseleave"]))
}